<ul class="list-group" *ngIf="openIdProfile">
    <li class="list-group-item nav-level-1" routerLink="">Home</li>
    <li
        class="list-group-item nav-level-1"
        routerLinkActive="nav-active"
        routerLink="history"
    >
        History
    </li>
    <li
        class="list-group-item nav-level-1"
        routerLinkActive="nav-active"
        routerLink="subscriptions"
    >
        Subscriptions
    </li>
    <li
        class="list-group-item nav-level-2"
        routerLinkActive="nav-active"
        routerLink="subscriptions-plans"
        *ngIf="openIdProfile.canCreateSubscription"
    >
        Plans
    </li>
    <li
        class="list-group-item nav-level-1"
        routerLinkActive="nav-active"
        routerLink="transaction"
    >
        Transactions
    </li>
    <li
        class="list-group-item nav-level-1"
        routerLinkActive="nav-active"
        routerLink="users"
        *ngIf="openIdProfile.isOperator"
    >
        Users
    </li>
    <li
        class="list-group-item nav-level-1"
        routerLinkActive="nav-active"
        routerLink="fees"
        *ngIf="openIdProfile.isOperator"
    >
        Fees
    </li>
    <li
        class="list-group-item nav-level-1"
        routerLinkActive="nav-active"
        routerLink="config"
        *ngIf="openIdProfile.isOperator"
    >
        Config
    </li>
</ul>
